export const SIZE = 50;
